import { login, logout,GetVerifyCode } from '../../api/login'
import Cookies from 'js-cookie'
import hui from 'h_ui/dist/h_ui.min.js'
import secret from '../../secret/secret.js'


const user = {
  state: {
    user: '',
    // token: Cookies.get('Admin-Token'),
    token: sessionStorage['token'],
    optAuths: [],
    roles: []
  },
  //定义一下可变量
  mutations: {
    LOGIN_SUCCESS: () => {
      //console.log('登录成功')
    },
    LOGOUT_USER: state => {
      state.user = ''
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_OPT_AUTHS: (state, optAuths) => {
      state.optAuths = optAuths
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
  },
  actions: {
    // 登录
    // 将token信息保存
    Login({ commit, state }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login( secret.encryptDES(username), secret.encryptDES(userInfo.password), userInfo.checkcode,sessionStorage['codeId']).then(response => {
          if(response.data.errcode=='0'){

            commit('SET_TOKEN', response.data.data.token)
            //获取token信息
            commit('SET_ROLES', [response.data.data.role]);
            sessionStorage['roles'] = JSON.stringify([response.data.data.role])
            sessionStorage['token'] = response.data.data.token
            //存入前端缓存
            sessionStorage['username'] = response.data.data.username
            sessionStorage['userId'] = response.data.data.userid
            sessionStorage['userType'] = response.data.data.userType;
            // resolve(response.data.data)
          }else {
            hui.hMessage.error(response.data.errmsg)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetInfo({ commit }, userInfo) {
      let roles = JSON.parse(sessionStorage['roles'])
      commit('SET_ROLES', roles);
      console.log("GetInfo")
    },
    GetVerifyCode(uri){
      GetVerifyCode(uri).then(response=>{
        console.log(response)
        sessionStorage['codeId']=response.data.data.value
      }).catch(error => {
        reject(error)
      })
    },
    // 登出
    // 将浏览器保存的token及权限清除
    Logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(sessionStorage['token']).then(response => {
          commit('SET_TOKEN', '')
          // Cookies.remove('Admin-Token')
          // Cookies.remove('lock')
          window.sessionStorage.removeItem('menus')
          window.sessionStorage.removeItem('menusType')
          window.sessionStorage.removeItem('username')
          window.sessionStorage.removeItem('userId')
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('roles')
          // window.sessionStorage.removeItem('userType')
          resolve()
        }).catch((err) => {
          // console.log(err)
          hui.hMessage.error("未退出成功")
        })
      })
    },
    ReLogin({ commit, state }) {
      commit('SET_TOKEN', '')
      Cookies.remove('Admin-Token')
      Cookies.remove('lock')
       window.sessionStorage.removeItem('roles')
      window.sessionStorage.removeItem('userid')
      window.sessionStorage.removeItem('username')
      window.sessionStorage.removeItem('token')
      // window.sessionStorage.removeItem('userType')
      location.reload()
    }
  }
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js